import { render } from "./ScrollToTop.vue?vue&type=template&id=cc0471ca&scoped=true"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"

import "./ScrollToTop.vue?vue&type=style&index=0&id=cc0471ca&scoped=true&lang=css"

import exportComponent from "D:\\wamp64\\www\\comd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0471ca"]])

export default __exports__